import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard, IonSlides, IonSlide} from '@ionic/react';
import React, { useState, useRef } from 'react';
import axios from 'axios';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { useHistory } from "react-router-dom";
import { IonItem, IonAlert, IonIcon,IonLabel, IonInput, IonButton, IonSelect, IonSelectOption, IonRadioGroup, IonRadio, IonListHeader, isPlatform } from '@ionic/react';
//import GoogleLogin from 'react-google-login';
import "@codetrix-studio/capacitor-google-auth";
import { Plugins } from '@capacitor/core';
import { set } from '../services/storage.service';
import { logoGoogle, logoApple } from 'ionicons/icons';
import './Register.css';
import { Marker } from 'react-leaflet';

export interface MyEvent {
    file: string;
}
const plat = isPlatform('iphone');
const ipad = isPlatform('ipad');
const webapp = isPlatform('mobileweb');

function saveToStorage(savetoken:any,saveuser:any,saveemail:any,savenicename:any,saveID:any) {
    if (savetoken) {    
    set("cred", JSON.stringify({ "email": saveemail, "userid": saveID, "nicename": savenicename, "firstname": saveuser,  "authtoken":savetoken}))
    return true;
    }
    return false;
}
const Register: React.FC = () => {
    const history = useHistory();
    const [age, setAge] = useState<string>('Over13');
    const [parentemail, setParentEmail] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [user, setUser] = useState<string>('');
    const [fname, setFname] = useState<string>('');
    const [lname, setLname] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [password2, setPassword2] = useState<string>('');
    const [selected, setSelected] = useState<string>('student');
    const [iserror, setIserror] = useState<boolean>(false);
    const [issuccess, setIssuccess] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [swiper, setSwiper] = useState<any>({});
    const [currentcheck, setCurrent] = useState<any>('0');

    const validateAge = () => {
        //if less than 13 then validate parent email or hide one or the other. 
        if (!age) {
            setMessage("Age is required");
            setIserror(true);
            return;
        }else{
            //handleSlidesControlNext();
        }
    }

    //const handleSlidesControlPrev = () =>{ swiper.slidePrev(300);document?.querySelector("ion-content")?.scrollToTop(500); console.log('scroll top');}
    async function signInWithApple() {
        const {SignInWithApple} = Plugins
  
        SignInWithApple.Authorize()
        .then((response:any) => {
           //get signed into apple here I guess. 
          let result = response;
          console.log("res",response);
          const email = response.response.user + "@explorermindsetapp.com";
          console.log(email);
  
          if(response) {
              console.log("res65:",response);
              const id = response.response.user;
              axios.get('https://explorermindsetapp.com/wp-json/appl/v2/check?id='+id,{
              //axios.get('https://expmindapp.wpengine.com/wp-json/appl/v2/check?id='+id,{
              })
              .then(function(response){
                console.log(response);
                let saveID = response['data']['userId'];
                    if (saveID === "nouser"){
                        console.log('create user');
                        let first = 'givenName';
                        let last = 'familyName';
                        let sendemail = ""; 
                        let sendfirst = ""; 
                        let sendlast = "";
  
                        if(email){sendemail = email;}else{sendemail="";}
                        if(first){sendfirst = first;}else{sendfirst="";}
                        if(last){sendlast = last;}else{sendlast="";}
                        console.log(email,sendemail);
                        //axios.post("http://expmindapp.wpengine.com/wp-json/appl/v2/creator", {
                        axios.post("http://explorermindsetapp.com/wp-json/appl/v2/creator", {
                            id: id,
                            email: sendemail,
                            first_name: sendfirst,
                            last_name: sendlast,
                            imageURL: "",
                        }).then(function(response){
                            console.log(response);
                            
                           // console.log(response.id);
                            console.log("id",id);
                            //now create a token with the Google ID.
                            //axios.get("https://expmindapp.wpengine.com/wp-json/appl/v2/token?id="+id, {//I need some kind of JWT Token
                            axios.get("https://explorermindsetapp.com/wp-json/appl/v2/token?id="+id, {//I need some kind of JWT Token
                            }).then(function(response){
                                let firstname = response['data']['firstName'];
                                console.log(response);
                                //let lastname = response['data']['lastName'];
                                console.log('tokenator');//debug for validating
  
                                //console.log("response",response);
  
                                let savetoken = response['data']['token'];
                                let savenicename = response['data']['nicename'];
                                let saveuser = email;
                                let saveemail = email;
                                let saveID = response['data']['claims']['userId'];
  
                                //console.log("id: " + saveID);
  
                                if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                  history.push("/dashboard/" + email);
                                } else {
                                  console.log('Failed to store auth');
                                }
                                
                            }).catch(function(error){
                                console.log("error");
                            }).then(function(){
                            });
  
  
                            
                        }).catch(function(error){
                            console.log("error");
                        }).then(function(){
                        });
                    }else{
                      console.log("user already exists");
                      let firstname = response['data']['firstName'];
                      console.log(saveID);
                      //let lastname = response['data']['lastName'];
                          //axios.get("https://expmindapp.wpengine.com/wp-json/appl/v2/token?id="+id, {//test site
                        
                          axios.get("https://explorermindsetapp.com/wp-json/appl/v2/token?id="+id, {//live site
                          }).then(function(response){
                              console.log("resp",response);
                              console.log('tokenable');//debug for validating
  
                              console.log(response['data']['claims'])
                              let savetoken = response['data']['token'];
                              let savenicename = response['data']['nicename'];
                              let saveuser = email;
                              let saveemail = email;
                              let saveID = response['data']['claims']['userId'];
  
                              console.log("id: " + saveID);
                              if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                history.push("/dashboard/" + email);
                              } else {
                                console.log('Failed to store auth');
                              }
                          }).catch(function(error){
                              console.log("error");
                          }).then(function(){
                          });
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });
          }
  
        })
        .catch((response:any)=>{
          //console.log(response);
          return(response);
        })
      }
    const signIn = async () => {
        
        try{
         Plugins.GoogleAuth.signOut();
             let result =  await Plugins.GoogleAuth.signIn();
             console.log(result);
             if (result) {
                 console.log(result);
                 let id = result['id'];
                 let email = result['email'];
                 //now lets send it to the API
                 axios.get('https://explorermindsetapp.com/wp-json/ggle/v2/check?id='+id, {
                 //axios.get('https://expmindapp.wpengine.com/wp-json/ggle/v2/check?id='+id, {
                 })
                 .then(function (response) {
                     // handle success
                     console.log(response);
                     let saveID = response['data']['userId'];
                     if (saveID === "nouser"){
                         console.log('create user');
                         axios.post("https://explorermindsetapp.com/wp-json/ggle/v2/creator", {
                         //axios.post("http://expmindapp.wpengine.com/wp-json/ggle/v2/creator", {
                             id: id,
                             email: email,
                             first_name: result['givenName'],
                             last_name: result['familyName'],
                             imageURL: ['imageUrl'],
                         }).then(function(response){
                             console.log(response);
                             //now create a token. 
                             //console.log("create a token now.");
                             //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token
                             axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token
                             }).then(function(response){
                                 let firstname = response['data']['firstName'];
                                 let lastname = response['data']['lastName'];
                                 console.log('token');//debug for validating
                                 let savetoken = response['data']['token'];
                                 let savenicename = response['data']['nicename'];
                                 let saveuser = email;
                                 let saveemail = email;
                                 if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                   history.push("/dashboard/" + email);
                                 } else {
                                   console.log('Failed to store auth');
                                 }
                             }).catch(function(error){
                                 console.log("error");
                             }).then(function(){
                             });
                         }).catch(function(error){
                             console.log("error");
                         }).then(function(){
                         });
                         
                     }else{
                         console.log('they exist - create token');
                         let firstname = response['data']['firstName'];
                         let lastname = response['data']['lastName'];
                            //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token    
                            axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/token?id="+id, {//I need some kind of JWT Token
                             }).then(function(response){
                                 console.log('token');//debug for validating
                                 let savetoken = response['data']['token'];
                                 let savenicename = response['data']['nicename'];
                                 let saveuser = email;
                                 let saveemail = email;
                                 if (saveToStorage(savetoken,saveuser,saveemail,savenicename,saveID)) {//save account
                                   history.push("/dashboard/" + email);
                                 } else {
                                   console.log('Failed to store auth');
                                 }
                             }).catch(function(error){
                                 console.log("error");
                             }).then(function(){
                             });
                     }
                 })
                 .catch(function (error) {
                     // handle error
                     console.log(error);
                 })
                 .then(function () {
                     // always executed
                 });
             }
        }catch(e){
        }
         
     }
    const handleLogin = () => {
        
        if (!user) {
            setMessage("Username can't be blank");
            setIserror(true);
            return;
        }
        if (!email) {
            setMessage("Please enter a valid email");
            setIserror(true);
            return;
        }
        if (validateEmail(email) === false) {
            setMessage("Your email is invalid");
            setIserror(true);
            return;
        }
        if (!password || password.length < 6 || !password2 || password2.length < 6) {
            setMessage("Please enter your password - make sure that it is more than 6 characters");
            setIserror(true);
            return;
        }
        if (password2 !== password) {
            setMessage("Password Mismatch");
            setIserror(true);
            return;
        }
        if (!fname) {
            setMessage("Please enter your first name");
            setIserror(true);
            return;
        }
        if (!lname) {
            setMessage("Please enter your last name");
            setIserror(true);
            return;
        }

        //axios.post("https://expmindapp.wpengine.com/wp-json/wp/v2/users/register", {
        axios.post("https://explorermindsetapp.com/wp-json/wp/v2/users/register", {
            "email": email,
            "password": password,
            "username": user
        }, {
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if(parentemail !== ""){ //send an email to the parents
                console.log("send email");
                registerChild("wordpress",parentemail,email);
            }
            console.log(response.data.message);
            setMessage(response.data.message);
            setIssuccess(true);
            //history.push("/login/");//+ email
        })
        .catch(error => {
            console.log(error.response.data.message);
            setMessage(error.response.data.message);
            setIserror(true);
        })
    };
    function registerChild(type:string, parent_email:any,child_email:any){
        axios.get("https://explorermindsetapp.com/wp-json/ggle/v2/parents?parent_email="+parent_email+"&child_email="+child_email, {//I need some kind of JWT Token
        
        //axios.get("https://expmindapp.wpengine.com/wp-json/ggle/v2/parents?parent_email="+parent_email+"&child_email="+child_email, {//I need some kind of JWT Token
        }).then(function(response){
            //console.log('parents emailed');//debug for validating
            console.log(response);
            if(type === "google"){
                signIn();
            }else if(type === "apple"){
                signInWithApple();
            }else{
                console.log("success from wordpress"); 
            }
            return true;
        }).catch(function(error){
            console.log("not able to email");
            return false;
        }).then(function(){
            console.log("done");
        });
    }
    function validateEmail(email: string) {
        const re = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
        return re.test(String(email).toLowerCase());
    }
    const mySlides = useRef(null);
    const slideOpts = {
        initialSlide: 0,
        speed: 400,
        grabCursor: false,
        allowTouchMove: false,
      };
    const init = async function(this: any) {
        setSwiper(await this.getSwiper());
        //setCurrent(1);
    };
    const handleSlidesControlNext = () =>{ 
        swiper.slideNext(300);document?.querySelector("ion-content")?.scrollToTop(500); 
        console.log('scrolltop');
    }
    const handleSlidesControlBack = () =>{ 
        swiper.slidePrev(300);document?.querySelector("ion-content")?.scrollToTop(500); 
        console.log('scrolltop');
    }
    return (
        <IonPage>
            <IonHeader className="hcs">
                <IonButton class="button-small button button-clear button-positive" href="/home" fill="clear">
                        Back
                    </IonButton>
            </IonHeader>
            <IonContent fullscreen className="ion-padding">
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Register Now</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonAlert
                                isOpen={iserror}
                                onDidDismiss={() => setIserror(false)}
                                cssClass="my-custom-class"
                                header={"Error"}
                                message={message}
                                buttons={["Dismiss"]}
                            />
                            <IonAlert
                                isOpen={issuccess}
                                onDidDismiss={() => history.push("/home/")}
                                cssClass="my-custom-class"
                                header={"Congratulations"}
                                message={message}
                                buttons={["Dismiss"]}
                            />
                        </IonCol>
                    </IonRow>

                    <IonSlides
                    options={slideOpts} 
                    mode="ios"  
                    onIonSlidesDidLoad={init}  
                    ref={mySlides}>

                        <IonSlide>
                            <IonCard className="ioncard">
                            <h2>STEP 1</h2>
                            <IonLabel class="ion-padding">How old are you?</IonLabel>
                                <IonItem>
                                <IonLabel position="floating">Age</IonLabel>
                                <IonSelect value={age} placeholder="Select One" onIonChange={e => setAge(e.detail.value)} interface="popover">
                                    <IonSelectOption value="Over13">Over 13</IonSelectOption>
                                    <IonSelectOption value="Under13">Under 13</IonSelectOption>
                                </IonSelect>
                                </IonItem>
                                <IonButton expand="block" onClick={() => handleSlidesControlNext() }>Next</IonButton>
                            </IonCard>
                        </IonSlide>

                        <IonSlide className="ionslide">
                            <IonCard className="ioncard">
                                <IonItem className="alignleft">
                            <IonButton onClick={() => handleSlidesControlBack() } className="alignleft">Back</IonButton>
                            </IonItem>
                            <h2>STEP 2</h2>
                           <IonLabel class="ion-padding">
                           {(function() { //check to see if the toggle is applied
                            
                            if(age !== "Over13"){
                                return (
                                    <>
                                     Please enter a parent or guardian email below so they can approve your use of the Explorer Mindset App, and well as your email.
                                    </>
                                    )
                                }
                            })()} Choose your registration type.
                            </IonLabel>
                            <IonItem>
                            <IonGrid>
                            {(function() { //check to see if the toggle is applied
                            
                                if(age !== "Over13"){
                                    return (
                                        <>
                                        <IonRow>
                                        <IonCol>
                                        <IonItem>
                                            <IonLabel position="floating">Parent's Email</IonLabel>
                                            <IonInput
                                                type="email"
                                                value={parentemail}
                                                onIonChange={(e) => setParentEmail(e.detail.value!)}
                                            >
                                            </IonInput>
                                            </IonItem>
                                            </IonCol>
                                            </IonRow>
                                            <IonRow>
                                            <IonCol>
                                            <IonItem>
                                            <IonLabel position="floating">Your Email</IonLabel>
                                            <IonInput
                                                type="email"
                                                value={email}
                                                onIonChange={(e) => setEmail(e.detail.value!)}
                                            >
                                            </IonInput> 
                                            </IonItem> 
                                            </IonCol>
                                        </IonRow>
                                      </>
                                    )
                                }
                            })()} 
                                    <IonRow>
                                        
                                        {(function() { //check to see if the toggle is applied
                                            if(parentemail !== "" && email !== ""){
                                                if(validateEmail(parentemail) !== false && validateEmail(email) !== false){
                                                    return (
                                                        <>
                                                        <IonCol>
                                                            <IonButton size="large" className="login-button" onClick={() => registerChild("google",parentemail,email)} expand="block" fill="solid">
                                                                <IonIcon icon={logoGoogle} className="icon"></IonIcon>  Sign in with Google
                                                            </IonButton>
                                                            {(function() {
                                                                if((plat || ipad) && !webapp){//IOS show apple button
                                                                return(
                                                                    <IonButton size="large" className="apple-login-button" onClick={() => registerChild("apple",parentemail,email)} expand="block" fill="solid">
                                                                    <IonIcon icon={logoApple} className="icon"></IonIcon> Sign in with Apple
                                                                    </IonButton>
                                                                )
                                                                }
                                                                })()} 
                                                        </IonCol>
                                                        <IonCol>
                                                            <IonButton size="large" className="email-button" expand="block" onClick={() => handleSlidesControlNext() } fill="solid"> Sign in with Email
                                                            </IonButton>
                                                        </IonCol>
                                                        </>
                                                    )
                                                }
                                            }
                                        })()} 
                                        
                                         {(function() { //check to see if the toggle is applied
                                            if(age !== "Under13"){
                                                return (
                                                    <>
                                                    <IonCol>
                                                        <IonButton className="login-button" onClick={() => signIn()} expand="block" fill="solid">
                                                            <IonIcon icon={logoGoogle} className="icon"></IonIcon>  Sign in with Google
                                                        </IonButton>
                                                        {(function() {
                                                                if((plat || ipad) && !webapp){//IOS show apple button
                                                                return(
                                                                    <IonButton className="apple-login-button" onClick={() => signInWithApple()} expand="block" fill="solid">
                                                                    <IonIcon icon={logoApple} className="icon"></IonIcon>  Sign in with Apple
                                                                    </IonButton>
                                                                )
                                                                }
                                                                })()} 
                                                    </IonCol>
                                                    <IonCol>
                                                        <IonButton className="email-button" expand="block" onClick={() => handleSlidesControlNext() } fill="solid">Register with Email</IonButton>
                                                    </IonCol>
                                                    </>
                                                )
                                            }
                                        })()} 
                                         </IonRow>
                                </IonGrid>
                            </IonItem>
                            </IonCard >
                        </IonSlide>
                        <IonSlide>
                            <IonCard className="ioncard">
                                <IonItem className="alignleft">
                            <IonButton  onClick={() => handleSlidesControlBack() } className="alignleft">Back</IonButton>
                            </IonItem>
                            <h2>STEP 3</h2>
                            <IonLabel class="ion-padding">Create Account</IonLabel>
                            <IonGrid>
                            <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating">User Name</IonLabel>
                                <IonInput
                                    type="text"
                                    value={user}
                                    onIonChange={(e) => setUser(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating">Email</IonLabel>
                                <IonInput
                                    type="email"
                                    value={email}
                                    onIonChange={(e) => setEmail(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating"> Password</IonLabel>
                                <IonInput
                                    type="password"
                                    value={password}
                                    onIonChange={(e) => setPassword(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating"> Password Again</IonLabel>
                                <IonInput
                                    type="password"
                                    value={password2}
                                    onIonChange={(e) => setPassword2(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating">First Name</IonLabel>
                                <IonInput
                                    type="text"
                                    value={fname}
                                    onIonChange={(e) => setFname(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonItem>
                                <IonLabel position="floating">Last Name</IonLabel>
                                <IonInput
                                    type="text"
                                    value={lname}
                                    onIonChange={(e) => setLname(e.detail.value!)}
                                >
                                </IonInput>
                            </IonItem>
                        </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                    <IonRadioGroup value={selected} onIonChange={e => setSelected(e.detail.value)}>
                        <IonListHeader>
                            <IonLabel>User Type</IonLabel>
                        </IonListHeader>

                        <IonItem>
                            <IonLabel>Student</IonLabel>
                            <IonRadio slot="start" value="student" />
                        </IonItem>

                        <IonItem>
                            <IonLabel>Teacher</IonLabel>
                            <IonRadio slot="start" value="teacher" />
                        </IonItem>
                                </IonRadioGroup>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton expand="block" onClick={handleLogin}>Submit</IonButton>
                            </IonCol>
                        </IonRow>

                       
                            </IonGrid>
                            </IonCard>
                        </IonSlide>
                    </IonSlides>
                </IonGrid>
                </IonContent>
            </IonContent>
        </IonPage>
    );
};

export default Register;